module.exports = __webpack_public_path__ + "static/media/assistance_type_lock.b1469c19.svg";